
import './App.css';
import Dictionary from './Dictionary';

function App() {
  return (
    <div className="App">
      <div className='container'>
     <header>

     </header>
    
      <main>
        <Dictionary />

      </main>
    <footer>

    </footer>
    </div>
    </div>
  );
}

export default App;
